import styled from "styled-components";

const ButtonContainer = styled.div`
  margin-top: 0.5em;
  padding-bottom: 15px;
`;
export default ButtonContainer;
